// extracted by mini-css-extract-plugin
export var container = "_7b-0";
export var fallback = "_7b-5";
export var fallbackIcon = "_7b-6";
export var hidden = "_7b-2";
export var image = "_7b-3";
export var loaded = "_7b-4";
export var placeholder = "_7b-1";